/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
function getViewportWidth(){return Math.max(window.document.documentElement.clientWidth||0,window.innerWidth||0)}export{getViewportWidth as g};
//# sourceMappingURL=get-viewport-width-ab33e6e3.js.map